import router from "./index";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
import getPageTitle from "@/utils/get-page-title";

// NProgress 配置
NProgress.configure({ showSpinner: false });

// 白名单
const whiteList = ["/login", "/notices"];

// 资料综合查询是仅超级管理员可见的固定入口；服务端接口仍会独立校验，
// 此处只避免普通账号通过地址栏进入页面壳。
function isSuperAdmin() {
  const account = (store.getters.username || "").toLowerCase();
  const roles = store.getters.roles || [];
  return (
    account === "admin" ||
    roles.some((role) => (role.code || "").toLowerCase() === "admin")
  );
}

// 高风险或敏感资料页面会指定唯一后台账号。短信登录后的 account 可能是手机号，
// 因此前端只使用后端按真实账号和角色计算出的布尔值；接口仍会再次强制校验。
function hasRestrictedAccount(to) {
  const requiredAccount = to.meta && to.meta.restrictedAccount;
  if (!requiredAccount) {
    return true;
  }
  return store.getters.designatedSuperAdmin === true;
}

function canAccessRoute(to) {
  // 超级管理员页面不能因为被误分配了菜单权限而向普通账号开放。
  if (to.meta && to.meta.superAdmin && !isSuperAdmin()) {
    return false;
  }
  const permission = store.getters.permission;
  const hasPageAccess =
    permission.indexOf(to.path) !== -1 ||
    to.path === "/404" ||
    (to.meta && to.meta.superAdmin && isSuperAdmin());
  return hasPageAccess && hasRestrictedAccount(to);
}

// 路由切换之前
router.beforeEach(async (to, from, next) => {
  NProgress.start();

  document.title = getPageTitle(to.meta.title);

  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      const hasGetUserInfo = store.getters.username;
      if (hasGetUserInfo) {
        if (canAccessRoute(to)) {
          next();
        } else {
          next({ path: "/404" });
        }
      } else {
        try {
          const res = await store.dispatch("user/getInfo");
          // await store.dispatch("user/getInfo");
          const permission = store.getters.permission;
          if (canAccessRoute(to)) {
            next();
            // next({ path: res.menus[0].path });
          } else {
            // next({ path: "/404" });
            try {
              next({ path: permission[1] });
            } catch {
              next({ path: "/404" });
            }
          }
          if (to.path == "/statistics") {
            next({ path: res.menus[0].path });
          }
        } catch (error) {
          await store.dispatch("user/resetToken");
          // Message.error(error || "错误");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

// 路由切换之后
router.afterEach(() => {
  NProgress.done();
});
